<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <h3 class="is-6">Recuerde que si usted es un consumidor final, es decir, adquirió nuestros productos
        a través de distribuidor este proceso de radicación debe ser acorde al proceso de radicación en punto
        del distribuidor</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
}
</script>
